<template>
  <div class="solar-plant-item-packages">
    <div
      v-if="!assignedPackages || assignedPackages.length === 0"
      class="text-muted text-center py-3"
    >
      <i class="fa fa-box fa-2x mb-2 d-block"></i>
      {{ $t('no_packages_added') }}
    </div>
    <div v-else>
      <b-row
        v-for="(assignedPackage, index) in assignedPackages"
        :key="getPackageKey(assignedPackage, index)"
        class="package-row mb-2 mt-2"
      >
        <b-col lg="12" md="6" sm="12">
          <div class="d-flex align-items-center">
            <div class="package-info flex-grow-1">
              <router-link
                v-if="assignedPackage.itemPackage && assignedPackage.itemPackage.number"
                target="_blank"
                :to="{
                  name: 'ItemPackageEditPage',
                  params: { itemPackageNumber: assignedPackage.itemPackage.number },
                }"
                class="mr-2"
              >
                #{{ assignedPackage.itemPackage.number.toString().padStart(4, '0') }}
                <i class="fa fa-sm fa-external-link"></i>
              </router-link>
              <span v-if="assignedPackage.itemPackage && assignedPackage.itemPackage.name">
                {{ assignedPackage.itemPackage.name }}
              </span>
              <span v-else class="text-muted">-</span>
            </div>
            <button
              v-if="!isBlockReadOnly"
              class="btn btn-sm btn-danger ml-auto"
              @click="removePackage(index)"
              :title="$t('remove')"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { AccessBlockMixin } from '@/mixins/accessBlock';

export default {
  name: 'SolarPlantItemPackages',
  mixins: [AccessBlockMixin],
  props: {
    assignedPackages: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    getPackageKey(assignedPackage, index) {
      return (
        assignedPackage.itemPackage?._id || assignedPackage.itemPackage?.number || `pkg-${index}`
      );
    },
    getAddedByLabel(user) {
      if (!user) return '-';
      if (user.firstname && user.lastname) {
        return `${user.firstname} ${user.lastname}`;
      }
      return user.email || '-';
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return this.$d(date, 'short');
    },
    removePackage(index) {
      const packageToRemove = this.assignedPackages[index];
      if (packageToRemove && packageToRemove.itemPackage) {
        this.$emit('remove-package', packageToRemove.itemPackage.number);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.package-row {
  padding: 0.25rem 0;

  &:hover {
    background-color: #f8f9fa;
  }
}

.package-info {
  min-height: 32px;
  display: flex;
  align-items: center;
}
</style>
